import { Geist, Geist_Mono } from 'next/font/google';

const geist = Geist({
	weight: ['100', '300', '400', '500', '700'],
	style: ['normal'],
	subsets: ['latin'],
	variable: '--font-geist',
	display: 'swap',
});
const geistMono = Geist_Mono({
	weight: ['400', '500', '700'],
	style: ['normal'],
	subsets: ['latin'],
	variable: '--font-geist-mono',
	display: 'swap',
});
const fonts = [geist, geistMono];

export { fonts };
